import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteOmsPriorityFilter = {
  name: "deleteOmsPriorityFilter" as const,
  input: z.object({ id: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
